import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-lmsapi'

const OriginationBusinessApi = {
  // region origination-operation
  express (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/express`,
      input,
      success,
      failure
    )
  },

  transfer (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/transfer`,
      input,
      success,
      failure
    )
  },

  replaceFollowUpData (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/follow-up`,
      input,
      success,
      failure
    )
  },

  followUpReset (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/follow-up-reset`,
      input,
      success,
      failure
    )
  },

  getVerbalAgreementFlag (loanNo, success, failure) {
    return ajax.get(
      `${BASE_URL}/origination-operation/verbal-agreement/get`,
      {
        loanNo: loanNo
      },
      success,
      failure
    )
  },

  cacheVerbalAgreementFlag (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/verbal-agreement/cache`,
      input,
      success,
      failure
    )
  },

  checkBlackList (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/check-black-list`,
      data,
      success,
      failure
    )
  },

  changeLoanStatus (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/update-status`,
      data,
      success,
      failure
    )
  },

  verifyLoanStatus (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/verify-status`,
      data,
      success,
      failure
    )
  },
  batchUpdateLoanStatusToWithdrawn (data, success, failure, isLoading) {
    return ajax.post(
      `${BASE_URL}/origination-operation/batch-deny-loan `,
      data,
      success,
      failure,
      { showLoading: isLoading }
    )
  },
  // endregion

  // region origination-agreement
  previewLoanAgreement (loanId, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/preview`,
      { loanId: loanId },
      success,
      failure
    )
  },

  sendLoanAgreement (request, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/send`,
      request,
      success,
      failure
    )
  },

  voidLoanAgreement (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/void`,
      input,
      success,
      failure
    )
  },

  voidLoanAgreementByDocumentIdAndLoanId (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/document/void`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },

  suspendLoanAgreement (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/suspend`,
      input,
      success,
      failure
    )
  },

  getSignStatusFromEsw (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/esw-sign-status/get`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },

  listLoanAgreementDocument (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/document/list`,
      data,
      success,
      failure
    )
  },

  recoverLoanAgreement (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-agreement/recover`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  // endregion

  // region origination-resource

  getReminderCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-resource/reminder-count`,
      input,
      success,
      failure
    )
  },
  // endregion

  // region origination-generation
  initSlaveLoan (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-generation/slave-loan/initialize`,
      data,
      success,
      failure
    )
  },
  copyLoan (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-generation/copy-loan`,
      input,
      success,
      failure
    )
  },
  // endregion

  // region origination-calculator
  loanIntegratedComputation (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-calculator/integrated-computation`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  // endregion

  // region origination-loan-stamp
  verifyLoanStamp (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-loan-stamp/verify`,
      data,
      success,
      failure
    )
  },
  countLoanStamp (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-loan-stamp/count`,
      data,
      success,
      failure
    )
  },
  // endregion
  // region special-loan-amount
  specialLoanAmount (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/specify-loan-amount`,
      data,
      success,
      failure
    )
  },
  // endregion
  // region payment option
  sendEmail (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/api/loan/email/send`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  previewEmail (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/api/loan/email/preview`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  previewPaymentOptionEmail (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/payment-option-email/preview`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  sendPaymentOptionEmail (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/payment-option-email/send`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  previewOrdinaryNotificationEmail (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/notification/preview`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  sendNotification (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/notification/send`,
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  judgeSameDayLoan (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/same-day/judge`,
      data,
      success,
      failure
    )
  },
  judgeEnableStamp (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/enable-stamp/judge`,
      data,
      success,
      failure
    )
  },
  followUpJudge (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/follow-up/judge`,
      data,
      success,
      failure
    )
  },
  compressSignatureLink (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/origination-operation/compress/signature-link`,
      data,
      success,
      failure
    )
  },
  getWithReasonData (success, failure) {
    return ajax.get(
      `${BASE_URL}/withdraw-data/reasons`,
      null,
      success,
      failure
    )
  },
  getDenyReasonData (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/withdraw-data/deny-reason`,
      input,
      success,
      failure
    )
  },
  getLoanMilitary (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/mla/loan-military-data`,
        input,
        success,
        failure
    )
  },
  getMilitaryConfirmation (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/payment/military-confirmation`,
        input,
        success,
        failure
    )
  },
  getManualVerify (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/mla/manual-verify`,
        input,
        success,
        failure
    )
  },
  getManualVerifyPPS (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/mla/manual-verify-pps`,
        input,
        success,
        failure
    )
  },
  getRelatedRequestCode (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/fraud/related-request-id/list`,
        input,
        success,
        failure
    )
  },
  FraudReleased (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/fraud/released`,
        input,
        success,
        failure
    )
  },
  getFraudFlag (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/fraud/flag/get`,
        input,
        success,
        failure
    )
  },
  getReportsDiff (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/fraud/reports/diff`,
        input,
        success,
        failure
    )
  },
  getToBeConfirmQueue (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/to-be-confirmed-loan/list-queue-data`,
        input,
        success,
        failure
    )
  },
  getToBeConfirmQueueCount (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/to-be-confirmed-loan/queue-count`,
        input,
        success,
        failure
    )
  },
  getLitigantType (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/ilv/get`,
        input,
        success,
        failure
    )
  },
  verifyLitigant (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/ilv/verify`,
        input,
        success,
        failure
    )
  },
  verifyBatch (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/ilv/batch-verify`,
      input,
      success,
      failure
    )
  },
  getILVStatus (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/ilv/life`,
      input,
      success,
      failure
    )
  },
  getToCollectionLeftBalance (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/payment/collection-left-balance-preview`,
        input,
        success,
        failure
    )
  },
  getSignOutReasonList (input, success, failure) {
    return ajax.post(
        `${BASE_URL}/origination-restapi/offline/all`,
        input,
        success,
        failure
    )
  }
}

export { OriginationBusinessApi }
